import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import noop from 'lodash/noop';
import find from 'lodash/find';
import cn from 'classname';

import { getCurrencyIcon } from '../../../../../../../shared/js/get-currency-icon';
import DetailsTable from './details-table';

const propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	toggleDetails: PropTypes.func,
	listOfRefererTypes: PropTypes.array,
	currentCurrency: PropTypes.string,
	isIndexing: PropTypes.bool
};

const Table = ({
	table,
	intl,
	sortByColumn,
	showMoreRows,
	toggleDetails,
	listOfRefererTypes,
	currentCurrency,
	isIndexing
}) => (
	<div className="table-container">
		<table className="simple-table conversions-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{ table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								'active': table.sortedColumn.index === header.index,
								[table.sortedColumn.direction]: (
									table.sortedColumn.index === header.index && table.sortedColumn.direction
								),
								[header.className]: header.className
							})}
							onClick={() => header.direction ? sortByColumn(header.index) : noop}>{intl(header.title)}</th>
					))}
				</tr>
			</thead>

			<tbody
				className={cn({
					'simple-table__body': true,
					'table-indexing': isIndexing,
					'default-table-indexing': isIndexing
				})}
			>
				{ renderRows(
					table,
					intl,
					toggleDetails,
					listOfRefererTypes,
					currentCurrency
				) }
			</tbody>
		</table>
		<div className="table-container__navigation">
			{ table.shouldShowPaginationControl && (
				<button className="ui-btn ui-btn-secondary" onClick={() => showMoreRows()}>{intl('Show more')}</button>
			)}
		</div>
	</div>
);

const renderRows = (
	table,
	intl,
	toggleDetails,
	listOfRefererTypes,
	currentCurrency
) => {
	const elements = [];
	const { rows, detailsRowId, conversionExtendedData } = table;

	rows.forEach(row => {
		const shouldShowDetails = row.id === detailsRowId;
		const internalContacts = row.internal_name || row.internal_phone
			? `${row.internal_name} ${row.internal_phone}`
			: null;
		const extendedData = find(conversionExtendedData, { conversion_id: row.id });

		elements.push(
			<tr key={row.id} className={cn(shouldShowDetails && 'details--opened')}>
				<td className="date">
					<span>
						{`${moment(row.date).format('DD.MM.YYYY')} ${moment(row.date).format('HH:mm')}`}
					</span>
				</td>
				<td><span>{ row.id }</span></td>
				<td><span>{ row.offer }</span></td>
				<td className="ip"><span>{ row.ip }</span></td>
				<td><span>{ row.geo }</span></td>
				<td className="status">
					<span className={`status__label status__label--${row.status}`}>
						{row.status} {row.calls_count ? `(${row.calls_count})` : null}
					</span>
				</td>
				<td className="payout">
					<span>{ row.payout }</span>
					{ !currentCurrency && (
						<span className="payout__currency">{ getCurrencyIcon(row.currency) }</span>
					) }

				</td>
				<td className="affiliate"><span>{ row.affiliate }</span></td>
				<td className="terminal"><span>{ row.is_non_terminal ? 'true' : 'false' }</span></td>
				<td className="traffic-type"><span>{ row.traffic_type }</span></td>
				<td className="actions">
					<a
						href="javascript:"
						className={cn({
							'icon-details': true,
							'icon-details--close': shouldShowDetails
						})}
						onClick={() => {toggleDetails(row.id);}}
					/>
				</td>
			</tr>
		);

		shouldShowDetails && elements.push(
			<DetailsTable
				key={`${row.id}-details`}
				row={row}
				internalContacts={internalContacts}
				intl={intl}
				listOfRefererTypes={listOfRefererTypes}
				extendedData={extendedData}
			/>
		);
	});

	return elements;
};

Table.propTypes = propTypes;

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/conversions/main.js